/**
 * Created by seaasun on 2018/1/31.
 */
import notification from '@/components/common/notification'

import Landing from '@/pages/Landing'
import Landing2 from '@/pages/Landing2'
import Landing3 from '@/pages/Landing3'
// import Code404 from '@/pages/Code404'
import Code403 from '@/pages/Code403'
// import testt from '@/pages/testt'
import testSummary from '@/pages/testSummary'
import OrderHistory from '@/pages/OrderHistory'

import Order from '@/pages/order/Order'
import SignIn from '@/pages/SignIn'
import Reward from '@/pages/Reward'
import DigitalCampaigns from '@/pages/DigitalCampaigns'
import FreeDataDiagnostic from '@/pages/FreeDataDiagnostic'

import orderRoutes from '@/router/orderRoutes'

import Videos from '@/pages/Videos'
import SaveListCount from '@/pages/saveListCount'

export default [
  {
    path: '/',
    name: 'landing',
    component: Landing3,
    meta: {
      title: 'Home'
    }
  },
  {
    path: '/example',
    name: 'landing2',
    component: Landing2,
    meta: {
      title: 'Home'
    }
  },
  {
    path: '/403',
    name: '403',
    component: Code403,
    meta: {
      title: '403'
    }
  },
  {
    path: '/404',
    name: '404',
    // component: Code404,
    meta: {
      title: '404'
    },
    redirect: to => {
      notification.notice('error', 'Can not find the page, Take you to the landing page', {
        title: '404'
      })
      return { name: 'landing' }
    }
  },
  // {
  //   path: '/test',
  //   name: 'test',
  //   component: testt,
  //   meta: {
  //     title: 'Home'
  //   }
  // },
  {
    path: '/test/summary',
    name: 'test-summary',
    component: testSummary,
    meta: {
      title: 'Test'
    }
  },
  {
    path: '/order/:listType',
    name: 'order',
    component: Order,
    children: orderRoutes
  },
  {
    path: '/order',
    redirect: {
      name: 'landing'
    }
  },
  {
    name: 'reward',
    path: '/reward',
    component: Reward,
    meta: {
      title: 'Reward'
    }
  },
  {
    name: 'signin',
    path: '/signin',
    component: SignIn,
    meta: {
      title: 'Sign Up -Sales Leads On Demand'
    }
  },
  {
    name: 'digitalCampaigns',
    path: '/digitalCampaigns',
    component: DigitalCampaigns,
    meta: {
      title: 'Sign Up -Sales Leads On Demand'
    }
  },
  {
    name: 'freedatadiagnostic',
    path: '/freedatadiagnostic',
    component: FreeDataDiagnostic,
    meta: {
      title: 'Sign Up -Sales Leads On Demand'
    }
  },
  {
    path: '*',
    redirect: {
      name: '404'
    }
  },
  {
    path: '/videos',
    name: 'videos',
    component: Videos,
    meta: {
      title: 'Home'
    }
  },
  {
    path: '/orderhistory',
    name: 'orderHistory',
    component: OrderHistory,
    meta: {
      title: 'Order History'
    }
  },
  {
    path: '/slc',
    name: 'saveListCount',
    component: SaveListCount,
    meta: {
      title: 'Saved Lists'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js